(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.factory('securityEventTypes', ["feature", "modulesManager", function (feature, modulesManager) {
        var iconPostfix = '';
        var iconPrefix = 'icomoon-';
        var shadowItLabel = 'Shadow IT';
        function generateData() {
            if (feature.checkpointTheme) {
                iconPostfix = '-cp';
            }
            if (feature.sonicwallTheme) {
                shadowItLabel = 'Shadow SaaS';
            }
            var data = [
                {
                    autoId: 'security_events_table_filter_type_dropdown_item_dlp',
                    id: 'dlp',
                    label: 'DLP',
                    iconClass: iconPrefix + 'dlp' + iconPostfix
                },
                {
                    autoId: 'security_events_table_filter_type_dropdown_item_malware',
                    id: 'malware',
                    label: 'Malware',
                    iconClass: iconPrefix + 'malware' + iconPostfix
                },
                {
                    autoId: 'security_events_table_filter_type_dropdown_item_phishing',
                    id: 'phishing',
                    label: 'Phishing',
                    iconClass: iconPrefix + 'phishing' + iconPostfix
                },
                {
                    autoId: 'security_events_table_filter_type_dropdown_item_suspicious_malware',
                    id: 'suspicious_malware',
                    label: 'Suspicious Malware'
                },
                {
                    autoId: 'security_events_table_filter_type_dropdown_item_suspicious_phishing',
                    id: 'suspicious_phishing',
                    label: 'Suspicious Phishing'
                },
                {
                    autoId: 'security_events_table_filter_type_dropdown_item_shadow_it',
                    id: 'shadow_it',
                    label: shadowItLabel,
                    iconClass: iconPrefix + 'shadow_it' + iconPostfix
                },
                {
                    autoId: 'security_events_table_filter_type_dropdown_item_alert',
                    id: 'alert',
                    label: 'Alert'
                }
            ];
            if (feature.lastlineTheme) {
                data = _(data).reject(function (type) {
                    return type.id === 'dlp';
                });
            }
            if (!feature.hideAnomalyEvents) {
                data.splice(3, 0, {
                    autoId: 'security_events_table_filter_type_dropdown_item_anomaly',
                    id: 'anomaly',
                    label: 'Anomaly',
                    iconClass: iconPrefix + 'anomaly' + iconPostfix
                });
            }
            if (feature.showSpam) {
                data.push({
                    autoId: 'security_events_table_filter_type_dropdown_item_spam',
                    id: 'spam',
                    label: 'Spam'
                });
            }
            if (feature.showMarketing) {
                data.push({
                    autoId: 'security_events_table_filter_type_dropdown_item_marketing',
                    id: 'marketing',
                    label: 'Marketing'
                });
            }
            if (feature.checkpointTheme) {
                data.push({
                    autoId: 'security_events_table_filter_type_dropdown_item_threat_extraction',
                    id: 'threat_extraction',
                    label: 'Threat Extraction'
                });
            }
            var showClicktimeProtection = modulesManager.activeSecApps().includes('clicktime_protection');
            var showOffice365Atp = modulesManager.activeSecApps().includes('office365_atp');
            if (showClicktimeProtection || showOffice365Atp) {
                data.push({
                    autoId: 'security_events_table_filter_type_dropdown_item_malicious_url',
                    id: 'malicious_url',
                    label: 'Malicious Url'
                }, {
                    autoId: 'security_events_table_filter_type_dropdown_item_malicious_url_click',
                    id: 'malicious_url_click',
                    label: 'Malicious Url Click'
                });
            }
            return data;
        }
        return {
            data: function () {
                return generateData();
            },
            get: function (id) {
                var found = _(generateData()).find(function (res) {
                    return res.id == id;
                });
                if (!found) {
                    return {
                        id: id,
                        label: id.charAt(0).toUpperCase() + id.slice(1)
                    };
                }
                return found;
            },
            defaultTypes: function () {
                var types = [];
                if (feature.lastlineTheme) {
                    types = [
                        'malware',
                        'phishing',
                        'shadow_it',
                        'suspicious_malware',
                        'suspicious_phishing',
                        'alert'
                    ];
                } else {
                    types = [
                        'dlp',
                        'malware',
                        'phishing',
                        'shadow_it',
                        'suspicious_malware',
                        'suspicious_phishing',
                        'alert'
                    ];
                }
                if (!feature.hideAnomalyEvents) {
                    types.splice(3, 0, 'anomaly');
                }
                if (feature.checkpointTheme) {
                    types.push('threat_extraction');
                }
                var showClicktimeProtection = modulesManager.activeSecApps().includes('clicktime_protection');
                var showOffice365Atp = modulesManager.activeSecApps().includes('office365_atp');
                if (showClicktimeProtection || showOffice365Atp) {
                    types.push('malicious_url', 'malicious_url_click');
                }
                return types;
            },
            defaultDaoParams: function () {
                if (feature.showSpam && feature.showMarketing && !feature.hideAnomalyEvents) {
                    return {};
                }
                return { filterEnum_type: _(generateData()).pluck('id').join(',') };
            }
        };
    }]);
}());